// extracted by mini-css-extract-plugin
export default {"linkview":"e4a69d07de7fe7477cf9","icon":"ba6ff6fad7ed851977b3"};